import { Transform } from 'class-transformer';
import { IsOptional, IsPhoneNumber, Length } from 'class-validator';

export class UpdateDistrictDto {
	_id?: string;
	@Length(1, 100)
	name: string;
	districtLinguistLinkId?: string | null;

	@IsOptional()
	@Transform(({ value }) => (value === '' ? undefined : value))
	@IsPhoneNumber('US', { message: 'Phone number must be a valid phone number' })
	contactNumber?: string;
}

export class UpdateDistrictListDto {
	_id?: string;
	name: string;
	districtLinguistLinkId?: string | null;
	contactNumber?: string;
}
